module.exports = __webpack_public_path__ + "img/logo.261a23bf.png";